export const getMicrophoneErrorMessage = (error) => {
  if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
    return 'Microphone access denied. Please allow microphone access in your browser and try again.';
  }
  if (error.name === 'NotFoundError') {
    return 'No microphone found. Please connect a microphone and try again.';
  }
  return `Could not access microphone: ${error.message}`;
};

export const createRecordingBlob = (chunks, fileType) =>
  new Blob(chunks, { type: `audio/${fileType}` });

export const getRecordingUploadError = (blob, fileName) =>
  !blob || !fileName ? 'Please enter a file name before uploading.' : '';
